import script from "./FlatChannelTool.vue?vue&type=script&lang=js"
export * from "./FlatChannelTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__